import clsx from 'clsx';
import styles from './recording-dot.module.css';

interface RecordingDotProps {
  className?: string;
}

/**
 * A small pulsing red dot marking an entity as being actively recorded. Reuses
 * the recording-HUD's visual language (the `--error` token + pulse animation).
 * Purely presentational — callers gate its presence on live-recording state.
 */
export function RecordingDot({ className }: RecordingDotProps) {
  return <span role="img" aria-label="Recording" className={clsx(styles.dot, className)} />;
}
